import script from "./SystemAnnouncement.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemAnnouncement.vue?vue&type=script&setup=true&lang=js"

import "./SystemAnnouncement.vue?vue&type=style&index=0&id=4305e39e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4305e39e"]])

export default __exports__